import { render, staticRenderFns } from "./layout-menu.vue?vue&type=template&id=749bedf6&"
import script from "./layout-menu.vue?vue&type=script&lang=ts&"
export * from "./layout-menu.vue?vue&type=script&lang=ts&"
import style0 from "./layout-menu.vue?vue&type=style&index=0&id=749bedf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports